import RegistrationPhoneVerify from './RegistrationPhoneVerify';

export default RegistrationPhoneVerify;
